'use client';

import {ArticleDateTime} from '@shared/Articles/ArticleSlug/ArticleDateTime/ArticleDateTime';
import ProxyImage from '@shared/ProxyImage/ProxyImage';
import classNames from '@sindresorhus/class-names';
import Link from 'next/link';

import {ArticleType} from '@strapi/types';

import {articleTestIds} from '../../ArticleTestIds';
import styles from './index.module.scss';

type Props = {
  card: ArticleType;
  onArticleClick?: () => void;
  articleUrl: string;
  enableTimeToReadInfo?: boolean;
  className?: string;
};

const ArticleCard = ({
  card,
  onArticleClick,
  articleUrl,
  enableTimeToReadInfo,
  className,
}: Props) => {
  const imageAttributes = card?.cardBackgroundImage;
  return (
    <Link
      key={card.cardTitle}
      href={`/${articleUrl}/${card.href}`}
      className={classNames(
        styles.card,
        !imageAttributes && styles.withoutImage,
        className,
      )}
      onClick={onArticleClick}
      data-testid={articleTestIds.proStorePageArticle}
    >
      {imageAttributes && (
        <div className={styles.imageContainer}>
          <ProxyImage className={styles.image} imageData={imageAttributes} />
        </div>
      )}
      <div>
        <h2 className={styles.title}>{card.cardTitle}</h2>
        {card.cardDescription && (
          <p className={styles.description}>{card.cardDescription}</p>
        )}

        {enableTimeToReadInfo && (
          <ArticleDateTime
            timeToRead={card.timeToRead}
            updatedAt={card.updatedAt}
            publishedAt={card.publishedAt}
          />
        )}
      </div>
    </Link>
  );
};

export default ArticleCard;
